import { availableLocales } from './entities/config';

interface TranslationSource {
    name: string;
    locale: string;
    translation: object;
}

export const getSources = async (scopes: string[]) => {
    const availableLangs = availableLocales;
    const sourcesList: TranslationSource[] = [];
    const flattenedArray: { name: string; locale: string }[] = [];

    availableLangs.forEach((lang) => {
        scopes.forEach((domain) => {
            flattenedArray.push({
                name: domain,
                locale: lang
            });
        });
    });

    const sources: TranslationSource[] = await flattenedArray.reduce(async (list, obj) => {
        const { default: translation } = await import(`../../../i18n-resources/${obj.locale}/${obj.name}.json`);
        const newList: TranslationSource[] = [
            ...(await list),
            {
                name: obj.name,
                locale: obj.locale,
                translation
            }
        ];

        return newList;
    }, Promise.resolve(sourcesList));

    return sources;
};
